import { render } from "./8.BookCall.vue?vue&type=template&id=52890abc&scoped=true"
import script from "./8.BookCall.vue?vue&type=script&lang=js"
export * from "./8.BookCall.vue?vue&type=script&lang=js"

import "./8.BookCall.vue?vue&type=style&index=0&id=52890abc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52890abc"]])

export default __exports__